let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8QCIL")).then(() => parcelRequire('7TpM2'));